var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import { useSlider } from "./SliderContext.js";
import styles from "@bookingcom/bui-core/css/_base/Slider.module.css";
var SliderItem = function (props) {
    var ref = React.useRef(null);
    var className = props.className, attributes = props.attributes, children = props.children, _a = props.index, index = _a === void 0 ? 0 : _a, _b = props.realIndex, realIndex = _b === void 0 ? 0 : _b, ghost = props.ghost;
    var itemClasses = classNames(styles.item, className);
    var slider = useSlider();
    React.useEffect(function () {
        var itemData = { index: index, realIndex: realIndex, el: ref.current };
        if (!ghost)
            slider.realItems[realIndex] = itemData;
        slider.items[index] = itemData;
        return function () {
            if (!ghost)
                slider.realItems.splice(realIndex, 1);
            slider.items.splice(index, 1);
        };
    }, [ghost, index, realIndex, slider.items, slider.realItems]);
    return (React.createElement("li", __assign({}, attributes, { className: itemClasses, ref: ref }), children));
};
export default SliderItem;
